/**
 * Puts 'fast-simon-autocomplete.css' inside the Fast Simon autocomplete's shadow
 * root - the only place it can take effect.
 *
 * The autocomplete ships with the Fast Simon app embed, not this theme (which is
 * why the commented-out widget script in theme.liquid does not stop it appearing),
 * and its init bundle renders everything inside
 * `container.attachShadow({mode:'open'})`. No theme stylesheet can match a node in
 * there.
 *
 * Two shadow hosts, both handled: .fast-ac-container (desktop) and
 * .mobile-fast-ac-container (mobile-optimised). Fast Simon creates whichever the
 * device needs lazily, on the first interaction, so this waits for it.
 *
 * `__fast_options.disable_ac_shadow_root` would let plain theme CSS in, but it
 * would also expose the widget to the theme's own rules - its markup uses class
 * names the theme styles heavily.
 *
 * The CSS is fetched as text and injected as a <style> so it is in hand before the
 * shopper types and the dropdown never paints a frame in the app's default Arial.
 * A <link> is the fallback, needing no CORS headers.
 */
(function () {
  var script = document.currentScript;
  var href = script && script.dataset.stylesheet;

  if (!href) return;

  var MARKER = 'data-makesy-autocomplete-styles';
  var HOSTS = '.fast-ac-container, .mobile-fast-ac-container';

  /* Started at load so the text resolves long before any interaction can create
     the container. Resolves to null on failure, which switches to a <link>. */
  var cssText = fetch(href)
    .then(function (response) {
      return response.ok ? response.text() : null;
    })
    .catch(function () {
      return null;
    });

  function inject(host) {
    var root = host.shadowRoot;

    /* No shadow root means disable_ac_shadow_root is on and the widget is already
       in the document - injecting there would apply this file's generic selectors
       (.item, .title, .image) to the whole storefront. */
    if (!root || root.querySelector('[' + MARKER + ']')) return false;

    cssText.then(function (text) {
      if (root.querySelector('[' + MARKER + ']')) return;

      var node;

      if (text) {
        node = document.createElement('style');
        node.textContent = text;
      } else {
        node = document.createElement('link');
        node.rel = 'stylesheet';
        node.href = href;
      }

      node.setAttribute(MARKER, '');
      root.appendChild(node);
    });

    return true;
  }

  function sync() {
    var hosts = document.querySelectorAll(HOSTS);
    var injected = false;

    for (var i = 0; i < hosts.length; i++) {
      if (inject(hosts[i])) injected = true;
    }

    return injected;
  }

  if (sync()) return;

  /* Unthrottled and disconnecting on the first hit, both deliberate: the callback
     runs as a microtask after the container is appended and before paint, so the
     first frame is already branded, and Fast Simon creates one container per
     device mode and reuses it. The subtree is the whole document because the
     container's parent depends on Fast Simon's own configuration. */
  var observer = new MutationObserver(function () {
    if (sync()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
